import * as React from "react";
import { Card, CardContent } from "../../components/ui/card.tsx";
import { MoreHorizontal, ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "../../components/ui/button.tsx";

const payments = [];  // Empty array instead of hardcoded payments

export default function RecentPayments() {
  const [isMobile, setIsMobile] = React.useState(false);
  const [visiblePayments, setVisiblePayments] = React.useState(3);
  const [isExpanded, setIsExpanded] = React.useState(false);

  // Check if we're on mobile device
  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Toggle expanded view on mobile
  const toggleExpandedView = () => {
    if (isMobile) {
      setIsExpanded(!isExpanded);
      setVisiblePayments(isExpanded ? 3 : payments.length);
    }
  };

  return (
    <Card className="w-full">
      <CardContent className="p-3 sm:p-6">
        <div className="flex items-center justify-between mb-2 sm:mb-4">
          <h3 className="text-base font-semibold">Recent Payments</h3>
        </div>

        {payments.length === 0 ? (
          <div className="py-8 text-center">
            <p className="text-gray-500">No recent payments</p>
          </div>
        ) : (
          <>
            <div className="space-y-0.5">
              {payments.slice(0, isMobile ? visiblePayments : payments.length).map((payment, i) => (
                <div
                  key={i}
                  className={`flex flex-col sm:flex-row sm:items-center py-2.5 sm:py-3 px-3 sm:px-4 cursor-pointer ${
                    i % 2 === 0 ? 'bg-purple-50/30' : 'bg-blue-50/30'
                  }`}
                >
                  {/* Mobile Layout */}
                  {isMobile && (
                    <>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <div className="w-1.5 h-1.5 rotate-45 bg-gray-400" />
                          <span className="text-sm font-medium">{payment.name}</span>
                        </div>
                        <span className="text-sm font-medium">{payment.amount}</span>
                      </div>
                      <div className="flex justify-between items-center mt-1.5 pl-3.5">
                        <span className="text-xs text-gray-500">{payment.date}</span>
                        <span className={`text-xs ${payment.reasonColor}`}>{payment.reason}</span>
                      </div>
                    </>
                  )}
                  
                  {/* Desktop Layout */}
                  {!isMobile && (
                    <>
                      <div className="flex items-center min-w-[180px] gap-3">
                        <div className="w-1.5 h-1.5 rotate-45 bg-gray-400" />
                        <span className="text-sm font-medium">{payment.name}</span>
                      </div>
                      <div className="flex-1 grid grid-cols-3 items-center">
                        <span className="text-sm text-gray-500">{payment.date}</span>
                        <span className="text-sm font-medium">{payment.amount}</span>
                        <span className={`text-sm ${payment.reasonColor}`}>{payment.reason}</span>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* Mobile View - Show More Button */}
            {isMobile && visiblePayments < payments.length && !isExpanded && (
              <Button
                variant="outline"
                size="sm"
                onClick={toggleExpandedView}
                className="w-full mt-2 text-xs h-8"
              >
                Show All Payments
              </Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
